/*
 * @Descripttion: 
 * @Version: 0.0.1
 * @Author: zhaozheng
 * @Date: 2021-10-11 16:38:49
 * @LastEditors: zhaozheng
 * @LastEditTime: 2021-10-11 17:00:32
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '../routes';
import store from '../store/index';

Vue.use(VueRouter);

// 可合并其他 router
const __routers = [...routes];
const router = new VueRouter({
    mode: 'hash',
    base: process.env.ROUTER_BASE,
    routes: __routers,
});
router.beforeEach((to, from, next) => {
    if (to && to.path && to.path == '/login') {
        store.commit('set_path', from.fullPath)
        // 暂时修改为重定向其他页面
        // router.push({ path: '/notice' })
    }
    next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js